export interface IQuestion {
  name: string;
  default: (string | number | string[] | number[])[];
  description: string | null;
  disabled?: boolean;
  group: string | null;
  hidden: boolean;
  inputs: string[];
  multiple: boolean;
  options: any[];
  order: string | null;
  outputs: object;
  required: boolean;
  type: QuestionType;
  min: number;
  max: number;
  initialKey: string; // Name of question key that gets overriden in case question name is provided
  indicative?: boolean;
  origin?: QuestionOrigin;
}

export enum QuestionOrigin {
  USER = 'user',
  AUTO = 'auto',
  EMPTY = 'empty',
}

export enum QuestionType {
  NUMBER = 'number',
  LIST = 'list',
  TABLE = 'table',
  BOOLEAN = 'boolean',
  TEXT = 'text',
  RADIO = 'radio',
  COLOR = 'color',
}
